import { useState } from 'react';
import { Box, Button, Card, CardContent, Chip, Stack, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { cardStyles, metaStripStyles } from './eventDetailsStyles';

const formatCategoryLabel = (category) => {
  if (!category) return 'Event';
  return String(category)
    .replace(/[_-]/g, ' ')
    .trim()
    .replace(/\b\w/g, (char) => char.toUpperCase());
};

const EventAboutCard = ({ paragraphs = [], learningPoints = [], category = '' }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const hasLongDescription = paragraphs.join('').length > 500;

  return (
    <Card sx={cardStyles.section}>
      <CardContent>
        <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 2 }}>
          <InfoOutlinedIcon sx={metaStripStyles.icon} />
          <Typography variant="h6" sx={{ fontWeight: 700 }}>{`About This ${formatCategoryLabel(category)}`}</Typography>
        </Stack>
        <Box
          sx={{
            display: { xs: isExpanded || !hasLongDescription ? 'block' : 'none', sm: 'block' },
          }}
        >
          {paragraphs.map((paragraph, index) => (
            <Typography key={index} variant="body1" sx={{ mb: 1.5 }}>{paragraph}</Typography>
          ))}
        </Box>
        {hasLongDescription && !isExpanded && (
          <Typography
            variant="body1"
            sx={{
              display: { xs: '-webkit-box', sm: 'none' },
              overflow: 'hidden',
              WebkitBoxOrient: 'vertical',
              WebkitLineClamp: 8,
              whiteSpace: 'pre-line',
            }}
          >
            {paragraphs.join('\n\n')}
          </Typography>
        )}
        {hasLongDescription && (
          <Button
            onClick={() => setIsExpanded((expanded) => !expanded)}
            sx={{ display: { xs: 'inline-flex', sm: 'none' }, px: 0, minWidth: 0, textTransform: 'none' }}
          >
            {isExpanded ? 'Read less' : 'Read more'}
          </Button>
        )}
        {learningPoints.length > 0 && (
          <Stack direction="row" spacing={1} useFlexGap sx={{ mt: 2, flexWrap: 'wrap' }}>
            {learningPoints.map((point, index) => <Chip key={index} label={point} />)}
          </Stack>
        )}
      </CardContent>
    </Card>
  );
};

export default EventAboutCard;
